import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { changePassword } from "../../../redux/actions/auth";
import ChangePasswordForm from "./ChangePasswordForm";

const initialValues = {
  previousPassword: "",
  newPassword: "",
  repeatedNewPassword: "",
};

const ChangePasswordDialogContainer = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState();
  const loading = useSelector((state) => state.auth?.changePassword?.loading)
  useEffect(() => {
    if (open) {
      setFormValues(initialValues);
    }
  }, [open])

  const handleSubmit = (values) => {
    dispatch(changePassword({
      claveAnterior: values.previousPassword,
      claveNueva: values.newPassword,
    })).then(() => {
      toast.success("Contraseña actualizada correctamente");
      handleClose();
    })
  };

  return (
    <ChangePasswordForm
      open={open}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      initialValues={formValues}
      loading={loading}

    />
  )
}

export default ChangePasswordDialogContainer;